import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getAllRows } from "../ReportElementHelper";

class CriminalRecordsNimbus extends Component {
  componentDidMount() { }

  render() {
    const rows = [];
    const criminalRecords = this.props.node;
    _.forEach(criminalRecords, (node, index) => {
      const recs = [];
      getAllRows(
        node,
        recs,
        this.props,
        _.get(node, "crimeDetails[0].$.display"),
        0,
        "",
        true,
        true,
        true
      );
      rows.push(
        <Table columns={1} key={`crim_rec_nim_${index}`}>
          <Table.Body>
            <Table.Row className={"page-title-black report-sub-section-header"}>
              <Table.Cell colSpan={2}>Criminal Record</Table.Cell>
            </Table.Row>
            {recs}
          </Table.Body>
        </Table>
      );
    });
    if (rows.length < 1) return null;
    return (
      <Table columns={1}>
        <Table.Body>
          <Table.Row className={"page-title-black report-sub-section-header"}>
            <Table.Cell colSpan={2}>Criminal Records </Table.Cell>
          </Table.Row>
          {rows}
        </Table.Body>
      </Table>
    );
  }
}

export default CriminalRecordsNimbus;



// WEBPACK FOOTER //
// ./src/components/reports/Criminal/CriminalRecordsNimbus.js